var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoResultsFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 760,
    height: 180,
    viewBox: "0 0 760 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11698",
    "data-name": "Group 11698",
    transform: "translate(-580 -286)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_13",
    "data-name": "Line 13",
    x2: 760,
    transform: "translate(580 455.5)",
    fill: "none",
    stroke: "#cacaca",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-git-pull-request",
    "data-name": "Icon feather-git-pull-request",
    transform: "translate(638.25 381.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M39.583,27.917A11.667,11.667,0,1,1,27.917,16.25,11.667,11.667,0,0,1,39.583,27.917Z",
    transform: "translate(33.667 33.667)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M26.583,14.917A11.667,11.667,0,1,1,14.917,3.25,11.667,11.667,0,0,1,26.583,14.917Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804",
    "data-name": "Path 3804",
    d: "M14.083,6.5H25.75a7.778,7.778,0,0,1,7.778,7.778V41.5",
    transform: "translate(28.056 8.417)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805",
    "data-name": "Path 3805",
    d: "M6.5,9.75V56.417",
    transform: "translate(8.417 16.833)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-git-pull-request-2",
    "data-name": "Icon feather-git-pull-request",
    transform: "translate(1202.5 385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3802-2",
    "data-name": "Path 3802",
    d: "M16.25,27.917A11.667,11.667,0,1,0,27.917,16.25,11.667,11.667,0,0,0,16.25,27.917Z",
    transform: "translate(-16.25 30.417)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803-2",
    "data-name": "Path 3803",
    d: "M3.25,14.917A11.667,11.667,0,1,0,14.917,3.25,11.667,11.667,0,0,0,3.25,14.917Z",
    transform: "translate(43.417 -3.25)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3804-2",
    "data-name": "Path 3804",
    d: "M33.528,6.5H21.861a7.778,7.778,0,0,0-7.778,7.778V41.5",
    transform: "translate(-2.417 5.167)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3805-2",
    "data-name": "Path 3805",
    d: "M6.5,9.75V56.417",
    transform: "translate(51.833 13.583)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2961",
    "data-name": "Rectangle 2961",
    transform: "translate(835 313)",
    fill: "#e4edfe",
    stroke: "#276ef1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 142,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 141,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2962",
    "data-name": "Rectangle 2962",
    transform: "translate(975 313)",
    fill: "#e4edfe",
    stroke: "#276ef1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 142,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 109,
    height: 141,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2953",
    "data-name": "Rectangle 2953",
    transform: "translate(890 286)",
    fill: "#e4edfe",
    stroke: "#276ef1",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 180,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 139,
    height: 179,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-search",
    "data-name": "Icon ionic-ios-search",
    d: "M118.151,111.17,86.167,78.894A45.582,45.582,0,1,0,79.249,85.9l31.774,32.066a4.923,4.923,0,0,0,6.948.18A4.952,4.952,0,0,0,118.151,111.17Zm-67.8-24.88A35.987,35.987,0,1,1,75.805,75.75,35.774,35.774,0,0,1,50.35,86.289Z",
    transform: "translate(909.5 325.507)",
    fill: "#276ef1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_ionic-md-sad",
    "data-name": "Icon ionic-md-sad",
    transform: "translate(922.964 339.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3812",
    "data-name": "Path 3812",
    d: "M29.194,20.25a20.337,20.337,0,0,0-18.38,11.509h36.76A20.337,20.337,0,0,0,29.194,20.25Z",
    transform: "translate(7.843 21.949)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3814",
    "data-name": "Path 3814",
    d: "M26.536,23.372a5.51,5.51,0,0,0,5.611-5.611,5.611,5.611,0,0,0-11.222,0A5.51,5.51,0,0,0,26.536,23.372Z",
    transform: "translate(23.988 8.702)",
    fill: "#646464"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3815",
    "data-name": "Path 3815",
    d: "M16.3,23.372a5.51,5.51,0,0,0,5.611-5.611A5.51,5.51,0,0,0,16.3,12.15a5.51,5.51,0,0,0-5.611,5.611A5.51,5.51,0,0,0,16.3,23.372Z",
    transform: "translate(7.251 8.702)",
    fill: "#646464"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-git-pull-request-3",
    "data-name": "Icon feather-git-pull-request",
    transform: "translate(859 423) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805-3",
    "data-name": "Path 3805",
    d: "M0,46.667V0",
    transform: "translate(11.667 0)",
    fill: "none",
    stroke: "#276ef1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-git-pull-request-4",
    "data-name": "Icon feather-git-pull-request",
    transform: "translate(1135.25 317.75) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3805-4",
    "data-name": "Path 3805",
    d: "M6.5,9.75V56.417",
    transform: "translate(8.417 16.833)",
    fill: "none",
    stroke: "#276ef1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-file-text",
    "data-name": "Icon feather-file-text",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 730.523, 338.804)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3816",
    "data-name": "Path 3816",
    d: "M31.5,3H11.1A5.1,5.1,0,0,0,6,8.1V48.9A5.1,5.1,0,0,0,11.1,54H41.7a5.1,5.1,0,0,0,5.1-5.1V18.3Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3817",
    "data-name": "Path 3817",
    d: "M21,3V18.3H36.3",
    transform: "translate(10.5 0)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3818",
    "data-name": "Path 3818",
    d: "M32.4,19.5H12",
    transform: "translate(4.2 11.55)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3819",
    "data-name": "Path 3819",
    d: "M32.4,25.5H12",
    transform: "translate(4.2 15.75)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3820",
    "data-name": "Path 3820",
    d: "M17.1,13.5H12",
    transform: "translate(4.2 7.35)",
    fill: "none",
    stroke: "#cacaca",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-file-empty",
    "data-name": "Icon metro-file-empty",
    d: "M43.207,12.313a41.114,41.114,0,0,0-3.952-4.52,41.118,41.118,0,0,0-4.52-3.952C32.4,2.126,31.262,1.928,30.612,1.928H8.126A3.631,3.631,0,0,0,4.5,5.555v39.17a3.631,3.631,0,0,0,3.627,3.627H41.493a3.631,3.631,0,0,0,3.627-3.627V16.436c0-.65-.2-1.784-1.913-4.122Zm-6-2.469a39.572,39.572,0,0,1,3.29,3.689h-6.98V6.555A39.531,39.531,0,0,1,37.2,9.845Zm5.015,34.88a.735.735,0,0,1-.725.725H8.126a.735.735,0,0,1-.725-.725V5.555a.735.735,0,0,1,.725-.725H30.612V14.985a1.451,1.451,0,0,0,1.451,1.451H42.218Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 1138.553, 337.508)",
    fill: "#cacaca"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResultsFound);
export default __webpack_public_path__ + "static/media/no-results-found.9c4904c0f952d3e930a5fd0d5573c29a.svg";
export { ForwardRef as ReactComponent };